import { render, staticRenderFns } from "./BcContainer.vue?vue&type=template&id=259d9781&scoped=true"
import script from "./BcContainer.vue?vue&type=script&lang=ts"
export * from "./BcContainer.vue?vue&type=script&lang=ts"
import style0 from "./BcContainer.vue?vue&type=style&index=0&id=259d9781&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259d9781",
  null
  
)

export default component.exports